import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../api/axios";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";

const VerifyPhone = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { phone, email } = location.state || { phone: "", email: "" };

  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // רפרנסים לכל אחד משדות הקוד
  const codeRefs = useRef([]);

  // מעבר אוטומטי לשדה הבא
  const handleChange = (value, index) => {
    const newCode = [...code];
    newCode[index] = value.slice(-1); // אם המשתמש הדביק יותר מתו אחד, ניקח רק את האחרון
    setCode(newCode);

    // אם הוקלד תו תקין (לא ריק) ויש שדה נוסף, נעביר פוקוס אליו
    if (value && index < code.length - 1) {
      codeRefs.current[index + 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const verificationCode = code.join("");

    try {
      await axiosInstance.post(
        `/users/verify-phone?phone=${phone}&code=${verificationCode}`
      );
      setSuccess("אימות הטלפון בוצע בהצלחה!");
      setError("");
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.detail || "קוד אימות שגוי.");
      setSuccess("");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
        // רקע גרדיאנט נעים
        background: "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
      }}
    >
      <Card
        sx={{
          maxWidth: 600,
          width: "100%",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          borderRadius: 3,
          p: { xs: 2, md: 4 },
        }}
      >
        <CardContent>
          <Typography
            variant="h4"
            component="h2"
            textAlign="center"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            אימות אימייל
          </Typography>

          {/* <Typography variant="body1" textAlign="center" sx={{ mb: 1 }}>
            קוד אימות נשלח ל: <strong>{phone}</strong>
          </Typography> */}
          <Typography variant="body2" textAlign="center" sx={{ mb: 3 }}>
            קוד אימות נשלח ל: <strong>{email}</strong>
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2, fontWeight: 500 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 2, fontWeight: 500 }}>
              {success}
            </Alert>
          )}

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 1.5,
                direction: "ltr", // קביעת כיוון משמאל-לימין עבור הקוד
              }}
            >
              {code.map((num, index) => (
                <TextField
                  key={index}
                  variant="outlined"
                  value={num}
                  onChange={(e) => handleChange(e.target.value, index)}
                  inputRef={(el) => (codeRefs.current[index] = el)}
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: "center",
                      fontSize: "1.3rem",
                      width: "50px",
                      height: "50px",
                    },
                  }}
                />
              ))}
            </Box>

            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{
                mt: 2,
                width: { xs: "100%", md: "50%" },
                backgroundColor: "#1976d2",
                ":hover": { backgroundColor: "#1565c0" },
              }}
            >
              לאמת
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default VerifyPhone;
